import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LoginController } from '../../services';
import { IInviteRegisterReq } from '../../types/requests';
import { IBaseResponse, TAxiosError } from '../../types/responses';
import { useError } from '../useCommon';
import { useLoginAPI } from './useLogin';

export function useRegisterAPI() {
  const { t } = useTranslation('welcome');
  const {
    mutate: loginMutate,
  } = useLoginAPI();
  const navigation = useNavigate();

  const { enqueueSnackbar } = useSnackbar();
  const { handleReqError } = useError();

  const registerApi = (data: IInviteRegisterReq) => LoginController().register<IBaseResponse & { email: string }>(data);

  return useMutation(registerApi, {
    onSuccess: (rsp, variables) => {
      if (rsp?.success && 'email' in rsp) {
        enqueueSnackbar(`${t('welcomeToMgm')}`, { variant: 'success' });

        if (rsp?.email) {
          const data = {
            email: rsp?.email ?? '',
            password: variables.password ?? '',
            isRedirect: true,
            isHashPassword: false,
            isDisplayToast: true,
          };

          loginMutate(data);
        } else {
          navigation('/');
        }
      } else if (rsp?.error && rsp.error?.response?.status) {
        handleReqError(rsp.error);
      } else if ('msg' in rsp) {
        console.error(`ERROR! invite register failed! ${rsp.msg}`);
      }
    },
    onError: (err: TAxiosError) => {
      console.error(`ERROR! invite register request threw an Exception! ${err}`);
    },
  });
}
